import { modifyRolePending, modifyRoleSuccess, modifyRoleFail } from "./UserRoleModifySlice";
import { deleteRolePending, deleteRoleSuccess, deleteRoleFail } from "./UserRoleDeleteSlice";
import { fetchSingleUserRole, userRoleModify , userRoleDelete } from "../../../api/userApi";
import Swal from "sweetalert2";
export const userRoleModification = (frmDt) => async (dispatch) => {
   
    try {
        dispatch(modifyRolePending());
        const result = await userRoleModify(frmDt);
        result.status === "success"
            ? dispatch(modifyRoleSuccess(result.message))
            : dispatch(modifyRoleFail(result.message));

            console.log("userRoleModify "+result);
            // console.log("try block");
            console.log(result.status);
            console.log('actions '+result.message);
            return result;
    } catch (error) {
        // console.log("catch block");
        const err = JSON.parse(JSON.stringify(error.response.data.error));
     
        dispatch(modifyRoleFail(err.msg));
        console.log(error)
    }

}



export const getSingleUserRole = (id) => async (dispatch) => {
   console.log('act'+id);

   try {
    //call the api
   dispatch(modifyRolePending());
   const result = await fetchSingleUserRole(id);
   if(result.userroles[0] && result.userroles[0].id){
   //console.log('check user profile');
       return dispatch(modifyRoleSuccess(result.userroles[0]));
   }
   dispatch(modifyRoleFail("Role is not found"));

  
} catch (error) {
   dispatch(modifyRoleFail(error));

}
   

}


export const newUserRoleDeletion = (frmDt) => async(dispatch) => {

    try {
        dispatch(deleteRolePending());
        const result = await userRoleDelete(frmDt);
        result.status ==="success" 
        ? dispatch(deleteRoleSuccess("Role deleted"))
        : dispatch(deleteRoleFail(result.message));
        
    } catch (error) {
       // console.log("catch block");
        const err= JSON.parse(JSON.stringify(error));
        console.log(error);
       // console.log(err.message);
        //console.log(JSON.parse(JSON.stringify(error)));
        dispatch(deleteRoleFail(error.message));
        Swal.fire(err.msg, '', 'error')
    }
    
}

